import styled from 'styled-components';

const HeroLoading = styled.div`
  padding: 35px 0 35px 0;

  .topHeading {
    margin-bottom: 20px;

    span {
      height: 30px;
    }
  }

  .subHeading1 {
    margin-bottom: 10px;
    span {
      height: 20px;
    }
  }

  .accountTotal {
    margin-bottom: 10px;

    span {
      height: 40px;
    }
  }

  .accountValuation {
    margin-bottom: 10px;
    span {
      height: 20px;
    }
  }

  .accountValues {
    margin: 8px 0 8px;
    height: 33px;
  }

  .accountValuesText {
    height: 17px;
  }
`;

export default HeroLoading;
